module.exports = __webpack_public_path__ + "img/schema_corset_1b.ea17cbdf.svg";